import { GAPI_LOADED, GAPI_CHECKING } from './types';

export const gapiLoaded = (loaded = true) => ({
  type: GAPI_LOADED,
  loaded,
});

export const gapiChecking = (checking = true) => ({
  type: GAPI_CHECKING,
  checking,
});
